




























































import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Helpers
import { Meta } from '@/helpers/decorators'

// Mixins
import Errors from '@/mixins/Errors'
import Contact from '@/mixins/Contact'
import Table from '@/mixins/Table'
import Date from '@/mixins/Date'

// Models
import Affiliation from '@/models/Affiliation'
import AffiliationUser from '@/models/AffiliationUser'

// Components
import Box from '@/components/common/Box.vue'
import InfoBox from '@/components/common/InfoBox.vue'
import ImageViewer from '@/components/common/ImageViewer.vue'
import ModalWrapper from '@/components/common/ModalWrapper.vue'

// Views
import AddAffiliationUserForm from '@/views/company/forms/AddAffiliationUserForm.vue'

@Component({
  components: {
    Box,
    InfoBox,
    ImageViewer,
    ModalWrapper,
    AddAffiliationUserForm
  }
})
export default class AffiliationsCompany extends Mixins(Errors, Contact, Table, Date) {
  affiliations: any[] = null
  loading = false
  loadingMore = false

  addUserModaleActive = false
  currentCode = null
  currentDesc = null

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale

  @Meta
  metas() {
    return {
      title: this.$t('company.menu.affiliations'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  async mounted() {
    await this.fetch()
  }

  async fetch() {
    try {
      this.loading = true
      const res = await this.$api.affiliation.fetchAffiliations(this.token, { limit: 20, offset: 0 })
      this.affiliations = res.data.map((affiliation) => {
        const a = new Affiliation(affiliation)
        a.parseAffiliation(this.locale)
        return {...a, expanded: false, accounts: null }
      })
    } finally {
      this.loading = false
    }
  }

  async fetchAccounts(affiliation, index) {
    try {
      this.loadingMore = true
      const res = await this.$api.affiliation.fetchAffiliationUsers(this.token, affiliation.code)
      if (res.data && res.data.length > 0) {
        this.affiliations[index].accounts = res.data.map((user) => new AffiliationUser(user))
      } else {
        this.affiliations[index].accounts = []
      }
    } finally {
      this.loadingMore = false
    }
  }

  async triggerExpand(affiliation, index) {
    this.affiliations[index].expanded = !this.affiliations[index].expanded
    if (!this.affiliations[index].accounts) {
      await this.fetchAccounts(affiliation, index)
    }
  }

  creationformatedDate(date) {
    return this.formatedDate(date, 'D MMM YYYY')
  }

  async deleteAffiliation(code, props) {
    const res = await this.$api.affiliation.deleteAffiliationUser(this.token, code, props.row.id)
    const affiliationIndex = this.affiliations.findIndex((affiliation) => affiliation.code === code)
    this.affiliations[affiliationIndex].accounts.splice(props.index, 1)
    this.$toast.open(this.$t('company_affiliations.code.delete.confirmation') as string)
  }

  removeAffiliationUser(code, props) {
    this.$dialog.confirm({
      title: this.$t('global.warning') as string,
      message: this.$t('company_affiliations.code.delete.confirm.description') as string,
      confirmText: this.$t('global.continue') as string,
      cancelText: this.$t('global.button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => this.deleteAffiliation(code, props)
    })
  }

  closeUserModale() {
    this.addUserModaleActive = false
  }

  addAccountTrigger(code, desc) {
    this.currentCode = code,
    this.currentDesc = desc
    this.openUserModale()
  }

  openUserModale() {
    this.addUserModaleActive = true
  }

  async reload() {
    await this.fetch()
  }
}
